import {ConfigsProperties} from './index'

const config: ConfigsProperties = {
    BASE_API: 'https://pricebook-api.iwstech.com/',
    SHA1_SALT: '6sJJnUiq',
    QINIU_HOST: 'http://drptest.erp-ax.cn/',
}

export default config
